import { CFTokens } from '../../tokens';
/* eslint-disable sort-keys */
export const CFBaseLogoTokens = {
    COLORS: {
        accent: CFTokens.COLOR.TEXT_AND_ELEMENT_ACCENT,
        alternate: CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE,
        boost: CFTokens.COLOR.TEXT_AND_ELEMENT_BOOST,
        brand: CFTokens.COLOR.TEXT_AND_ELEMENT_BRAND,
        'brand-alternate': CFTokens.COLOR.TEXT_AND_ELEMENT_EMPHASIS,
        default: CFTokens.COLOR.TEXT_AND_ELEMENT_DEFAULT,
        emphasis: CFTokens.COLOR.TEXT_AND_ELEMENT_EMPHASIS,
    },
};
